import React, { useState, useEffect } from "react";
import { Box, Stack, Skeleton } from "@mui/material";
import Post from "./Post";

function Feed() {

  const [loading, setLoading] = useState(true);
  
  const [post, setPost] = useState([]);

  useEffect(() => {
    fetch("/api/contents")
    .then(res => {
      return res.json();
    })
    .then(data => {
      setPost(data);
    })
  }, []);
  
  setTimeout(() => {
    setLoading(false);
  }, [1000]);

  return (
    <Box flex={4} p={{ xs: 0, md: 1 }}>
      {loading ? (
        <Stack spacing={1} sx={{ margin: 5 }}>
          <Skeleton variant="text" height={100} />
          <Skeleton variant="text" height={20} />
          <Skeleton variant="text" height={20} />
          <Skeleton variant="rounded" height={200} />
          <Skeleton variant="rounded" height={300} />
        </Stack>
      ) : (
        post.map(post => (
          <Post
            key={post.id} 
            tag={post.tag}
            title={post.title}
            content={post.content}
            image={post.image}
            date={post.uploadDate}
          />
        ))
      )}
    </Box>
  );
}

export default Feed;